import { Link, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, openSideNav, registerRoutes } from '../../../func';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import Axios from 'axios';
import moment from 'moment';

const UninvoicedOrders = () => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const [orderList, setOrderList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          getInvoiceList: {
            func: () => {
              setIsLoading(true);

              Axios.get('/api/v2/order/header/read/all/notinvoiced', {
                params: authData,
              })
                .then(({ data }) => setOrderList(data || []))
                .catch(logOut)
                .finally(() => setIsLoading(false));
            },
            type: 'r',
          },
        },
        path
      ),
    path
  );

  useEffect(() => {
    networkCalls.getInvoiceList();
  }, []);

  return (
    <div className="main">
      <div style={{ display: 'flex' }}>
        <Link to="/" onClick={openSideNav} style={{ marginRight: '12px' }}>
          <i className="material-icons black-text">menu</i>
        </Link>
        <Link to="/">Home</Link>
        <i className="material-icons">chevron_right</i>
        <Link to="/accounting">Accounting</Link>
        <i className="material-icons">chevron_right</i>
        <span className="grey-text">Uninvoiced Orders Report</span>
      </div>
      <div className="row">
        <h5 className="center">All Uninvoiced Orders</h5>
        <div className="divider" />
      </div>
      {isLoading ? (
        <div className="progress blue">
          <div className="indeterminate" />
        </div>
      ) : (
        <div className="row">
          <table className="highlight">
            <thead>
              <tr>
                <th>Pharmacy</th>
                <th>Customer Number</th>
                <th>Order Number</th>
                <th>Date Serviced</th>
                <th>Rep On Site</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orderList?.map(order => {
                const {
                  id,
                  orderNumber,
                  pharmacy: { name, customerNumber },
                  orderHeaderStatus: {
                    timestamp,
                    employee: { firstName, lastName },
                  },
                } = order;

                return (
                  <tr key={id}>
                    <td style={{ padding: '2px' }}>{name}</td>
                    <td style={{ padding: '2px' }}>{customerNumber}</td>
                    <td style={{ padding: '2px' }}>{orderNumber}</td>
                    <td style={{ padding: '2px' }}>
                      {timestamp ? moment(timestamp).format('MM/DD/YY') : ''}
                    </td>
                    <td style={{ padding: '2px' }}>
                      {firstName} {lastName}
                    </td>
                    <td style={{ padding: '2px' }}>
                      <Link
                        to={{
                          pathname: '/invoice/create',
                          state: { orderNumber },
                        }}
                      >
                        Create Invoice
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UninvoicedOrders;
